import { LuInstagram, LuLinkedin, LuMail } from "react-icons/lu";
import {
  ContactItem,
  Container,
  FooterBottom,
  FooterContainer,
  Grid,
  Link,
  List,
  ListItem,
  Logo,
  SectionTitle,
  SocialLink,
  SocialLinks,
  Text
} from "./styles";
import Image from "next/image";
import LinkNext from "next/link";
import { track } from "@/lib/analytics/track";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Container>
        <Grid>
          <div>
            <Logo href="/">
              <Image
                src="/images/logo-blue.png"
                alt="Logo DentalMap"
                width={128}
                height={25}
                style={{
                  height: "auto",
                  width: 128
                }}
              />
            </Logo>
            <Text>
              Transformando a gestão odontológica com tecnologia intuitiva e
              eficiente.
            </Text>
            <SocialLinks>
              <LinkNext
                href="https://www.instagram.com/dentalmap.oficial"
                target="_blank"
              >
                <SocialLink>
                  <LuInstagram size={20} />
                </SocialLink>
              </LinkNext>
              <LinkNext
                href="https://www.linkedin.com/company/dentalmap"
                target="_blank"
              >
                <SocialLink>
                  <LuLinkedin size={20} />
                </SocialLink>
              </LinkNext>
            </SocialLinks>
          </div>
          <div>
            <SectionTitle>Empresa</SectionTitle>
            <List>
              <ListItem>
                <Link href="/sobre">Sobre nós</Link>
              </ListItem>
            </List>
          </div>
          <div>
            <SectionTitle>Suporte</SectionTitle>
            <List>
              <ListItem>
                <Link href="/#faq">Ajuda & FAQ</Link>
              </ListItem>
              <ListItem>
                <Link
                  href={`https://wa.me/5538999568521?text=${encodeURIComponent(
                    "Olá! Vim pelo site do DentalMap e gostaria de mais informações."
                  )}`}
                  target="_blank"
                  onClick={() =>
                    track({ event: "whatsapp_cta_clicked", cta_type: "footer" })
                  }
                >
                  Contato
                </Link>
              </ListItem>
            </List>
          </div>
          <div>
            <SectionTitle>Contato</SectionTitle>
            <List>
              <Link href="mailto:contato@dentalmap.com.br">
                <ContactItem>
                  <LuMail size={20} />
                  <span>contato@dentalmap.com.br</span>
                </ContactItem>
              </Link>
            </List>
          </div>
        </Grid>
        <FooterBottom>
          <p>&copy; {currentYear} DentalMap. Todos os direitos reservados.</p>
          <div>
            <Link href="/termos-uso" target="_blank">
              Termos de Uso
            </Link>{" "}
            |{" "}
            <Link href="/politica-privacidade" target="_blank">
              Política de Privacidade
            </Link>{" "}
            |{" "}
            <Link href="/cookies" target="_blank">
              Cookies
            </Link>
          </div>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
}
